import k from "lodash";
import o, { useRef as p, useEffect as h } from "react";
import n from "prop-types";
import d from "classnames";
import { mintelGray300 as a, mintelWhite as c, mintelBlack as f, mintelRed400 as C } from "mintel-tokens";
import { I as S } from "./Icon-ByeAHRM4.es.js";
import { I as b } from "./IconButton-C3Bh2v_G.es.js";
import { S as E } from "./Spinner-CRP4P3TK.es.js";
import { T as m } from "./index-BB-Wk85r.es.js";
import { u as B } from "./utils-C0l876fA.es.js";
import { CSSTransition as x } from "react-transition-group";
import './Snackbar.css';const T = "SnackbarBody-module__body___UyWnl", R = "SnackbarBody-module__success___4sEkj", I = "SnackbarBody-module__error___g-Hm7", v = "SnackbarBody-module__loading___-Z9JL", q = "SnackbarBody-module__icon___AipT5", A = "SnackbarBody-module__leading___6rucL", N = "SnackbarBody-module__leader___JISpq", L = "SnackbarBody-module__message___msWDE", P = "SnackbarBody-module__action___iEYwl", s = {
  body: T,
  success: R,
  error: I,
  loading: v,
  icon: q,
  leading: A,
  leader: N,
  message: L,
  action: P
}, u = 20, z = {
  success: {
    icon: {
      name: "green_check"
    },
    defaultLeader: "Success!",
    darkBg: !1,
    closeIcon: {
      color: f,
      hoverColor: a
    },
    styles: s.success
  },
  error: {
    icon: {
      name: "warning",
      color: C,
      alt_color: c
    },
    defaultLeader: "Error",
    darkBg: !1,
    closeIcon: {
      color: f,
      hoverColor: a
    },
    styles: s.error
  },
  loading: {
    iconComponent: {
      color: c,
      size: 16,
      thickness: 2
    },
    defaultLeader: "We're preparing your download",
    darkBg: !0,
    closeIcon: {
      color: c,
      hoverColor: a
    },
    styles: s.loading
  },
  default: {
    darkBg: !0,
    closeIcon: {
      color: c,
      hoverColor: a
    }
  }
}, l = (t) => {
  const e = z[t.type], { t: i } = B(), _ = p(null), g = p(null);
  return h(() => (_.current = document.activeElement, t.action && g.current.focus(), () => {
    t.action && _.current?.focus();
  }), [t.action]), /* @__PURE__ */ o.createElement(
    "div",
    {
      className: d(s.body, e.styles),
      style: { lineHeight: `${u}px` },
      role: t.action ? "alertdialog" : "alert",
      tabIndex: t.action ? 0 : -1,
      ref: g
    },
    e.iconComponent && /* @__PURE__ */ o.createElement("div", { className: d(s.icon, s.leading) }, /* @__PURE__ */ o.createElement(
      E,
      {
        color: e.iconComponent.color,
        size: e.iconComponent.size,
        thickness: e.iconComponent.thickness
      }
    )),
    e.icon && /* @__PURE__ */ o.createElement("div", { className: d(s.icon, s.leading) }, /* @__PURE__ */ o.createElement(S, { ...e.icon, size: u })),
    (t.leader || e.defaultLeader) && /* @__PURE__ */ o.createElement("span", { className: s.leader }, /* @__PURE__ */ o.createElement(
      m.Heading6,
      {
        darkBg: e.darkBg,
        responsive: !0,
        tagName: "span"
      },
      t.leader || e.defaultLeader
    )),
    /* @__PURE__ */ o.createElement("span", { className: s.message }, /* @__PURE__ */ o.createElement(m.Body2, { darkBg: e.darkBg, responsive: !0 }, t.message)),
    t.action && /* @__PURE__ */ o.createElement(
      "button",
      {
        className: s.action,
        onClick: t.onAction,
        type: "button"
      },
      /* @__PURE__ */ o.createElement(m.Body, { darkBg: e.darkBg, responsive: !0 }, /* @__PURE__ */ o.createElement("strong", null, t.action))
    ),
    /* @__PURE__ */ o.createElement(
      b,
      {
        name: "close",
        label: t.action ? i("dismiss notification") : "",
        ariaHidden: !t.action,
        className: s.icon,
        onClick: t.onClose,
        size: u,
        ...e.closeIcon
      }
    )
  );
};
l.propTypes = {
  message: n.string.isRequired,
  onAction: n.func.isRequired,
  onClose: n.func.isRequired,
  action: n.string,
  leader: n.string,
  type: n.oneOf(["default", "success", "error", "loading"])
};
l.defaultProps = {
  action: null,
  leader: "",
  type: "default"
};
const O = "750", D = "SnackbarPopup-module__entering___7wuxf", W = "SnackbarPopup-module__entered___Q5Taf", w = "SnackbarPopup-module__exiting___ZlSTx", H = "SnackbarPopup-module__exited___hBOLL", r = {
  fadeOutTime: O,
  entering: D,
  entered: W,
  exiting: w,
  exited: H
};
class y extends o.Component {
  // eslint-disable-next-line react/sort-comp
  static getDerivedStateFromProps = (e, i) => e.closing && i.in ? { in: !1 } : null;
  state = { in: !1 };
  componentDidMount() {
    this.setState({ in: !0 }), this.timeout = setTimeout(() => this.setState({ in: !1 }), 5e3);
  }
  componentWillUnmount() {
    clearTimeout(this.timeout), this.props.onCloseComplete();
  }
  render() {
    return /* @__PURE__ */ o.createElement(
      x,
      {
        timeout: {
          enter: 0,
          exit: parseInt(r.fadeOutTime, 10)
        },
        classNames: {
          enter: r.exited,
          enterActive: r.entering,
          enterDone: r.entered,
          exit: r.entered,
          exitActive: r.exiting,
          exitDone: r.exited
        },
        in: this.state.in,
        onExit: this.props.onClose,
        onExited: this.props.onCloseComplete
      },
      /* @__PURE__ */ o.createElement("div", null, this.props.children)
    );
  }
}
y.propTypes = {
  onClose: n.func.isRequired,
  onCloseComplete: n.func.isRequired,
  children: n.node.isRequired,
  closing: n.bool.isRequired
};
class J extends o.Component {
  state = {
    closing: {},
    closed: {}
  };
  actionsTriggered = {};
  handleAction = (e) => {
    this.actionsTriggered[e.key] || (e.onAction(), this.actionsTriggered[e.key] = !0), this.handleClose(e);
  };
  handleClose = (e) => {
    this.setState(({ closing: i }) => ({
      closing: { ...i, [e.key]: !0 }
    }));
  };
  handleCloseComplete = (e) => {
    this.setState(({ closed: i }) => ({
      closed: { ...i, [e.key]: !0 }
    }));
  };
  render() {
    return /* @__PURE__ */ o.createElement("span", { "aria-live": "assertive" }, this.props.events.filter((e) => !this.state.closed[e.key]).map((e) => /* @__PURE__ */ o.createElement(
      y,
      {
        key: e.key,
        closing: !!this.state.closing[e.key],
        onClose: () => this.handleClose(e),
        onCloseComplete: () => this.handleCloseComplete(e)
      },
      /* @__PURE__ */ o.createElement(
        l,
        {
          ...e,
          onAction: () => this.handleAction(e),
          onClose: () => this.handleClose(e)
        }
      )
    )));
  }
}
const U = n.shape({
  // Almost the same as SnackbarBody.
  ...k.omit(l.propTypes, "onClose", "id"),
  key: n.string.isRequired,
  // This *must* be set if the prop action is set.
  onAction: n.func
});
J.propTypes = {
  /** An array of objects representing all the Snackbar events that have been triggered. */
  events: n.arrayOf(U).isRequired
};
export {
  J as S
};
